module.exports = __webpack_public_path__ + "static/img/download_user_mobile.5ba5383.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/download_user_mobile.png
// module id = jDX4
// module chunks = 8